
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "../../store";
import { debugData } from "../../utils/debugData";
import { isEnvBrowser } from "../../utils/misc";
import { useSocketEventOutsideRequest } from "../../hooks/useSocketEventOutsideRequest";
import { socketRequest } from "../../utils/socketRequest";

import { UserState, SET_PLAYERDATA } from "../../reducers/userReducer";
import { PermissionType, PlayerType, HardMoneyState, SET_HOUSEDATA, DEV_ADD_roommate, DEV_DELETE_roommate, DEV_SET_roommate_perms } from "../../reducers/hardmoneyReducer";
import { UIState, SET_activeTab, SET_hidden, SET_isLoading, SET_selectedRoommate } from "../../reducers/uiReducer";

import { throttle } from 'lodash';
import ToggleSwitch from "../GlobalComponents/ToggleSwitch/ToggleSwitch";
import { permission } from "process";
const PermissionList: React.FC = () => {
    const dispatch = useDispatch();
    const uiData = useSelector((state: RootState) => state.ui);
    const playerData = useSelector((state: RootState) => state.user);
    const hardmoneyData = useSelector((state: RootState) => state.hardmoney);

    const romData = hardmoneyData.roommates.find((roomateData) => roomateData.UserStateID === uiData.selectedRoommate);
    const currentPlayer = hardmoneyData.roommates.find((roomateData) => roomateData.UserStateID === playerData.UserState);
    if (!romData || !currentPlayer) return null;

    const canEditPerms = currentPlayer.permissions.includes(playerData.editPermsString);
    const canDeleteRoommate = currentPlayer.permissions.includes(playerData.deleteRoommatePermsString);
    
    const [setplayerPermissions, setSetplayerPermissions] = useState<string[]>([...romData.permissions]);
    const [permissionsChanged, setPermissionsChanged] = useState(false);

    // Update state when selected roommate or permissions change
    useEffect(() => {
        setSetplayerPermissions([...romData.permissions]);
    }, [uiData.selectedRoommate, romData.permissions]);

    // Check if permissions are different
    useEffect(() => {
        setPermissionsChanged(arePermissionsDifferent());
    }, [setplayerPermissions]);

    const arePermissionsDifferent = () => {
        const sortedCurrent = [...romData.permissions].sort();
        const sortedSet = [...setplayerPermissions].sort();

        return sortedCurrent.length !== sortedSet.length || sortedCurrent.some((perm, index) => perm !== sortedSet[index]);
    };

    // Toggle permission state
    const handleTogglePerm = (permID: string, toggle: boolean) => {
        setSetplayerPermissions((prev) => {
            const updatedPermissions = toggle ? [...prev, permID] : prev.filter((perm) => perm !== permID);
            return updatedPermissions;
        });
    };

    const fetchDeleteRoommate = useCallback(
        throttle(async (roomateID: number) => {
            dispatch(SET_isLoading(true));
            try {
                const res = await socketRequest("DeleteRoommate", {
                    houseID: hardmoneyData.houseID,
                    houseOwner: hardmoneyData.houseOwner,
                    playerSID: roomateID,
                }, hardmoneyData);
                if (res) {
                    dispatch(SET_selectedRoommate(0));
                    if (isEnvBrowser()) {
                        dispatch(DEV_DELETE_roommate(roomateID));
                    } else {
                        dispatch(SET_HOUSEDATA(res));
                    }
                } else {
                    throw new Error("Invalid roommate delete data received.");
                }
            } catch (err) {
                console.error("Error roommate delete data:", err);
            } finally {
                dispatch(SET_isLoading(false));
            }
        }, 3000),
        [dispatch]
    );

    const fetchUpdatePermissions = useCallback(
        throttle(async (roomateID: number) => {
            dispatch(SET_isLoading(true));
            try {
                const res = await socketRequest("ChangeRoommatePermissions", {
                    houseID: hardmoneyData.houseID,
                    houseOwner: hardmoneyData.houseOwner,
                    playerSID: roomateID,
                    newPermissions: setplayerPermissions,
                }, hardmoneyData);
                if (res) {
                    if (isEnvBrowser()) {
                        dispatch(DEV_SET_roommate_perms({
                            roommateSID: roomateID,
                            permissions: setplayerPermissions,
                        }));
                    } else {
                        dispatch(SET_HOUSEDATA(res));
                    }
                } else {
                    throw new Error("Invalid roommate data received.");
                }
            } catch (err) {
                console.error("Error roommate change data:", err);
            } finally {
                dispatch(SET_isLoading(false));
            }
        }, 3000),
        [dispatch, setplayerPermissions]
    );

    const handleDeleteRoommate = (e: React.MouseEvent) => {
        e.preventDefault();
        if (uiData.selectedRoommate > 0) {
            fetchDeleteRoommate(uiData.selectedRoommate);
        }
    };

    const handleSaveChanges = (e: React.MouseEvent) => {
        e.preventDefault();
        if (canEditPerms && uiData.selectedRoommate > 0 && permissionsChanged) {
            fetchUpdatePermissions(uiData.selectedRoommate);
        }
    };

    return (
        <div
            className="flexCenter fadeInPointFive"
            style={{
                width: "100%",
                height: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
                position: "relative",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: "column",
                textAlign: "left",
                //backgroundColor: "yellow",
                gap: "5vh",
                //padding: "3vh 0",
                color: "rgba(255, 255, 255, 0.9)",
                
            }}
        >
            <div
                style={{
                    border: "0.2vh solid rgba(90, 90, 90, 0.8)",
                    backgroundColor: "rgba(60, 60, 60, 0.8)",
                    height: "auto",
                    width: "100%",
                    padding: "2vh",
                    borderRadius: "0.5vh",
                    boxSizing: "border-box",
                }}
            >
                {/* permission list */}
                <div
                    style={{
                        height: "auto",
                        width: "100%",
                        //backgroundColor: 'purple',
                        display: "grid",
                        justifyContent: "center",
                        alignItems: "center",
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gridAutoRows: `repeact(1, 1fr)`,
                        gap: "2vh",
                        columnGap: "15%",
                    }}
                >
                    {hardmoneyData.permissions.map((permData, index) => {
                    const doesPlayerHavePerm = setplayerPermissions.includes(permData.permID);

                        return (
                            <div
                                key={index}
                                style={{
                                    //backgroundColor: "red",
                                    fontSize: "1.5vh",
                                    //width: "33%",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontWeight: "600",
                                }}
                            >
                                {permData.permName}

                                <div
                                    style={{
                                        //backgroundColor: "orange",
                                        width: "6.5vh",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <ToggleSwitch 
                                        defaultChecked={doesPlayerHavePerm}
                                        onToggle={(switched: boolean) => handleTogglePerm(permData.permID, switched)} 
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            {/* Lower section with save and delete roommate */}
            <div
                style={{
                    height: "auto",
                    width: "100%",
                    //backgroundColor: "gray",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <div
                    onClick={(e) => handleDeleteRoommate(e)}
                    style={{
                        border: canDeleteRoommate ? `0.2vh solid rgb(171, 28, 0)` : "0.2vh solid rgba(90, 90, 90, 0.8)",
                        backgroundColor: canDeleteRoommate ? `rgba(171, 28, 0, 0.2)` : "rgba(60, 60, 60, 0.8)",
                        padding: "1vh",
                        fontSize: "1.25vh",
                        fontFamily: 'Noto Sans',
                        fontWeight: "600",
                        borderRadius: "0.75vh",
                        transition: "border 0.5s ease, background-color 0.5s ease",
                        cursor: canDeleteRoommate ? "pointer" : "auto",
                    }}
                >
                    Delete Roommate
                </div>
                <div
                    onClick={(e) => handleSaveChanges(e)}
                    style={{
                        border: permissionsChanged && canEditPerms ? `0.2vh solid rgb(${uiData.schemeColor})` : "0.2vh solid rgba(90, 90, 90, 0.8)",
                        backgroundColor: permissionsChanged && canEditPerms ? `rgba(${uiData.schemeColor}, 0.2)` : "rgba(60, 60, 60, 0.8)",
                        padding: "1vh",
                        fontSize: "1.25vh",
                        fontFamily: 'Noto Sans',
                        fontWeight: "600",
                        borderRadius: "0.75vh",
                        transition: "border 0.5s ease, background-color 0.5s ease",
                        cursor: permissionsChanged && canEditPerms ? "pointer" : "auto",
                    }}
                >
                    Save Changes
                </div>
            </div>
        </div>
    );
};

export default PermissionList;
